export default (match, base) => {
    let idle = true;

    //Views
    const matchHeightElements = Array.from(document.querySelectorAll(match));
    const baseHeightElement = document.querySelector(base);

    if (matchHeightElements == null) return false;
    if (baseHeightElement == null) return false;

    const updateHeights = () => {
        const height = baseHeightElement.offsetHeight;

        matchHeightElements.forEach( (div) => {
            div.style.height = `${height}px`;
        });
    };

    window.addEventListener('load', (evt) => {
        if (! idle) {
            return;
        }

        idle = false;
        window.requestAnimationFrame(() => {
            updateHeights();
            idle = true;
        });
    });

    window.addEventListener('resize', (evt) => {
        if (! idle) {
            return;
        }

        idle = false;
        window.requestAnimationFrame(() => {
            updateHeights();
            idle = true;
        });
    });
};



// WEBPACK FOOTER //
// ./assets/js/modules/matchHeight.js